import type { Company } from '@/shared/api'
import { colorKeyToken } from '@/shared/lib/color-key'

/** `Company.colorKey` без совпадения (контракт расширят раньше, чем фронт) уезжает в серый. */
const FALLBACK = 'var(--ink-3)'

/**
 * Сервер отдаёт `colorKey`, не цвет (`openapi/components/schemas/session.yaml`) — палитра
 * живёт на фронте, токены из `tokens.css`. `violet` — токен `--violet`, а не сырой `oklch()`
 * из макета: сырое значение не сдвигалось бы в тёмной теме (см. комментарий у `--violet`
 * в tokens.css).
 */
export function companyColor(company: Pick<Company, 'colorKey'>): string {
  return colorKeyToken(company.colorKey, FALLBACK)
}
